module.exports = __webpack_public_path__ + "media/images/default/shared/footer/bg-line-md-fd906933944385e6667982726e644293.svg";